import React from "react";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import Video from "../../video/video";
import videoModalStyles from "./videoModal.module.css";
import { TExercise } from "../../../services/types/auth.types";
import i18n from "../../../i18n";

interface VideoModalContentProps {
  exercise: TExercise;
  onClose: () => void;
}

const VideoModalContent: React.FC<VideoModalContentProps> = ({ exercise, onClose }) => {
  const isRTL = i18n.dir() === 'rtl';
  
  return (
    <div className={videoModalStyles.modalContent} dir={i18n.dir()}>
      <div className={videoModalStyles.modalHeader}>
        <h2 className={videoModalStyles.modalTitle}>{exercise.title}</h2>
        <button 
          className={videoModalStyles.closeButton}
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
      </div>
      
      <div className={videoModalStyles.videoContainer}>
        <div className={videoModalStyles.videoWrapper}>
          <Video src={exercise.link} title={exercise.title} />
        </div>
      </div>
      
      {exercise.about && (
        <div className={videoModalStyles.descriptionContainer}>
          <h3 className={videoModalStyles.descriptionTitle}>{t("DESCRIPTION")}</h3>
          <p className={videoModalStyles.descriptionText}>{exercise.about}</p>
        </div>
      )}
    </div>
  );
};

export default VideoModalContent;